import React from "react";

const AccountSkeleton: React.FC = () => {
  return (
    <div className="relative px-14 py-10 max-sm:px-6 max-sm:py-8">
      <div className="relative">
        <h2 className="text-primary text-2xl mb-6 max-md:mb-5 max-md:text-2xl">
          Account details
        </h2>
        <div className="max-w-md mx-auto max-md:mb-12">
          {/* Skeleton for profile image */}
          <div className="text-center w-full col-span-2 mb-6 max-md:mb-4">
            <div className="w-40 h-40 m-auto rounded-full  bg-gray-300 skeleton "></div>

            {/* Skeleton for user name */}
            <div className="text-primary text-[26px] max-sm:text-lg mt-3 break-word !rounded-md">
              <div className="h-6 bg-gray-300 w-2/3 mx-auto skeleton mb-3 !rounded-md"></div>
            </div>
          </div>

          {/* Skeleton for input fields */}
          <div className="grid grid-cols-2 gap-4 max-sm:grid-cols-1 w-full mb-4">
            <div>
              <div className="h-6 bg-gray-300 w-1/2 mb-2 skeleton !rounded-md"></div>
              <div className="relative">
                <div className="h-12 bg-gray-300 w-full skeleton !rounded-md"></div>
              </div>
            </div>

            <div>
              <div className="h-6 bg-gray-300 w-1/2 mb-2 skeleton !rounded-md"></div>
              <div className="relative">
                <div className="h-12 bg-gray-300 w-full skeleton !rounded-md"></div>
              </div>
            </div>

            <div className="sm:col-span-2">
              <div className="h-6 bg-gray-300 w-1/2 mb-2 skeleton !rounded-md"></div>
              <div className="relative">
                <div className="h-12 bg-gray-300 w-full skeleton !rounded-md"></div>
              </div>
            </div>

            <div className="sm:col-span-2">
              <div className="h-6 bg-gray-300 w-1/2 mb-2 skeleton !rounded-md"></div>
              <div className="relative">
                <div className="h-12 bg-gray-300 w-full skeleton !rounded-md"></div>
              </div>
            </div>
          </div>

          {/* Skeleton for buttons */}
          <div className="grid grid-cols-1 gap-3 max-w-md mx-auto max-lg:mt-9">
            <div className="h-12 bg-gray-300 w-1/2 mx-auto skeleton !rounded-md"></div>
            <div className="h-6 bg-gray-300 w-1/3 mx-auto skeleton !rounded-md"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSkeleton;
